import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useCurrentUser } from '../context/UserContext';
import PageLoader from './PageLoader';
import UserEdit from './UserEdit/UserEdit';
import UserView from './UserView/UserView';
import UserViewDetails from './UserView/UserViewDetails';

export default function User() {
  const { loading, user, loadUser, setUser } = useCurrentUser();

  return loading ? (
    <PageLoader />
  ) : (
    <Routes>
      <Route path={`/details/edit`} element={<UserEdit user={user} loadUser={loadUser} />} />
      <Route path={`/details`} element={<UserViewDetails user={user} onUserChange={setUser} />} />
      <Route index element={ <UserView user={user} />} />
    </Routes>
  );
}
